<app-base-notification [base]="base">

  <div [innerHTML]="'notifications.profile_verified.text' | customLocale"></div>

</app-base-notification>
